import apollo from '@/graphql'

import BrandsQuery from '@/graphql/brand/BrandsQuery.gql'
import DeleteProductImage from '@/graphql/product/DeleteProductImage.gql'
import ProductDetailsQuery from '@/graphql/product/ProductDetailsQuery.gql'
import SaveProductDetails from '@/graphql/product/SaveProductDetails.gql'
import UnreviewedProductsQuery from '@/graphql/product/UnreviewedProductsQuery.gql'
import UploadProductImage from '@/graphql/product/UploadProductImage.gql'
import VendorsQuery from '@/graphql/vendor/VendorsQuery.gql'

// initial state
const state = {
  editableProductFields: {},
  productDetails: {},
}

// getters
const getters = {
  editableProductFields: st => st.editableProductFields,
  productDetails: st => st.productDetails,
}

// mutations
const mutations = {
  createProductDetails() {
    state.editableProductFields = {
      brand: {
        categoriesId: null,
        id: null,
        name: null,
        vendor: {
          id: null,
          name: null,
        },
      },
      primaryImagesId: null,
    }

    state.productDetails = { name: 'Create New Product' }
  },

  setEditableProductFields(st, productDetails) {
    if (!productDetails.brand) {
      state.editableProductFields = {
        clientUpc: productDetails.clientUpc,
        brand: { vendor: {} },
        id: productDetails.id,
        name: productDetails.name,
        primaryImagesId: productDetails.primaryImagesId,
        upc: productDetails.upc,
      }
    } else {
      state.editableProductFields = {
        clientUpc: productDetails.clientUpc,
        brand: {
          categoriesId: (productDetails.brand.category || {}).id,
          id: productDetails.brand.id,
          name: productDetails.brand.name,
          vendor: {
            id: (productDetails.brand.vendor || {}).id,
            name: (productDetails.brand.vendor || {}).name,
          },
        },
        id: productDetails.id,
        name: productDetails.name,
        primaryImagesId: productDetails.primaryImagesId,
        upc: productDetails.upc,
      }
    }
  },

  setProductDetails(st, productDetails) {
    state.productDetails = productDetails
  },
}

function getProductDetailsQuery() {
  return [state.productDetails.id].filter(id => id).map(id => ({
    query: ProductDetailsQuery,
    variables: { id: +id },
  }))
}

// actions
const actions = {
  deleteProductImage(context, { id, $message }) {
    apollo.defaultClient.mutate({
      mutation: DeleteProductImage,
      variables: { id: +id },
      refetchQueries: getProductDetailsQuery().concat([{
        query: UnreviewedProductsQuery,
      }]),
    }).catch((err) => {
      $message.error(err.graphQLErrors[0].message)
    })
  },

  loadProductDetails({ commit }, { id }) {
    apollo.defaultClient.watchQuery({
      fetchPolicy: 'network-only',
      query: ProductDetailsQuery,
      variables: { id: +id },
    }).subscribe(({ data: { productDetails } }) => {
      commit('setEditableProductFields', productDetails)
      commit('setProductDetails', productDetails)
    })
  },

  saveProductDetails(context, {
    fields, $message, $router,
  }) {
    const isCreation = !(fields || state.editableProductFields).id

    apollo.defaultClient.mutate({
      mutation: SaveProductDetails,
      variables: { fields: fields || state.editableProductFields },
      refetchQueries: getProductDetailsQuery().concat([{
        query: UnreviewedProductsQuery,
      }, {
        query: BrandsQuery,
      }, {
        query: VendorsQuery,
      }]),
    }).then(({ data: { saveProductDetails: { id } } }) => {
      $message({ message: 'Changes saved', type: 'success' })
      if (isCreation) {
        $router.push(`/product/${id}`)
      }
    }).catch((err) => {
      $message.error({ message: err.message })
    })
  },

  uploadProductImage(context, {
    fields, file, $message,
  }) {
    apollo.defaultClient.mutate({
      mutation: UploadProductImage,
      variables: { file, productsId: fields.id || state.productDetails.id },
      refetchQueries: getProductDetailsQuery().concat([{
        query: UnreviewedProductsQuery,
      }]),
    }).catch((err) => {
      $message.error(err.graphQLErrors[0])
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/product/ProductDetails.js